import { useCallback, useEffect, useMemo, useState } from "react";
import { post } from "../networking/RequestService";

function useGetAllUnits(params = {}, autoFetch = true) {
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const memoizedParams = useMemo(() => params, [JSON.stringify(params)]);

    const fetchDepartments = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await post({ fn: "getAllUnits", ...memoizedParams });
            const { departments } = response.data;
            const options = [];
            for (let i = 0; i < departments.length; i++) {
                for (let j = 0; j < departments[i].unitList.length; j++) {
                    options.push({
                        label: departments[i].unitList[j].name,
                        value: departments[i].unitList[j].id,
                    });
                }
            }
            setDepartments(options);
        } catch (error) {
            setError(error.response?.data?.text || "An unexpected error occurred");
        } finally {
            setLoading(false);
        }
    }, [memoizedParams]);

    useEffect(() => {
        if (autoFetch) {
            fetchDepartments();
        }
    }, [fetchDepartments, autoFetch]);

    return { departments, loading, error, fetchDepartments };
}

export default useGetAllUnits;
